import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

import R from 'common/res/R';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  title: {
    ...R.typography.weightBold,
    color: R.color.uiLightPrimary,
    fontSize: R.typography.fontSize.large,
  },
});

const HeaderOneLine = props => {
  return (
    <View style={styles.container}>
      <Text style={styles.title} numberOfLines={1}>
        {props.title}
      </Text>
    </View>
  );
};

HeaderOneLine.propTypes = {
  title: PropTypes.string.isRequired,
};

export default HeaderOneLine;
